import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { GlobalStyle as StashUIGlobalStyle, ThemeProvider } from '@stashinvest/ui';
import ErrorBoundary from 'stash/components/screens/error-boundary/ErrorBoundary';
import { createStore } from 'stash/store';
import Routes from './Routes';
import GlobalStyle from './GlobalStyle';
import DevTools from 'stash/components/screens/dev/DevTools';
import { deleteCookie, isNativeWebview, isNotProd, setUTMCookies } from 'stash/utils';
import Dialog from 'stash/components/global/Dialog';
import { SEGMENT_CDN_PROXY_URL, SEGMENT_WRITE_KEY } from 'stash/constants';
import { SegmentAnalyticsProvider } from './stash/hooks/useAnalytics';
import { datadogRum } from '@datadog/browser-rum';
import datadogRumConfig from 'stash/utils/datadogRum';
import { BanjoProvider } from '@stashinvest/react-banjo';
import { languageMap } from 'banjo';
import {
	ExperimentsContextUpdater,
	getLaunchDarklyProvider,
} from 'stash/components/experiments';
import './App.css';
import { NativeAuthProvider } from 'stash/components/native-auth-provider/NativeAuthProvider';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { createBrowserHistory } from 'history';
window.Stash.version = import.meta.env.VITE_APP_VERSION;

// TODO: incident mitigation remove from next release
deleteCookie('stashBankLinkCardDetails');

datadogRum.init(datadogRumConfig);

export const ReactApp = () => {
	const analytics = AnalyticsBrowser.load({
		writeKey: SEGMENT_WRITE_KEY,
		cdnURL: SEGMENT_CDN_PROXY_URL,
	});
	const history = createBrowserHistory();
	const store = createStore({ history, analytics });

	if (isNativeWebview()) {
		datadogRum.startSessionReplayRecording();
	}

	return (
		<Provider store={store}>
			<ThemeProvider>
				<BanjoProvider defaultLocale="en-us" languageMap={languageMap} variants={[]}>
					<StashUIGlobalStyle />
					<GlobalStyle />
					<NativeAuthProvider>
						<ExperimentsContextUpdater />
						<ErrorBoundary>
							{isNotProd() && <DevTools />}
							<SegmentAnalyticsProvider analytics={analytics}>
								<Routes history={history} />
							</SegmentAnalyticsProvider>
							<ThemeProvider mode="light">
								<Dialog />
							</ThemeProvider>
						</ErrorBoundary>
					</NativeAuthProvider>
				</BanjoProvider>
			</ThemeProvider>
		</Provider>
	);
};

(async () => {
	setUTMCookies();
	const LaunchDarklyProvider = await getLaunchDarklyProvider();

	ReactDOM.render(
		<LaunchDarklyProvider>
			<ReactApp />
		</LaunchDarklyProvider>,
		document.getElementById('root')
	);
})();
